import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import utils
import { convertToJalali } from "../../../../utils/date";

//import general components
import BaseDialog from "../../../common/base-dialog/base-dialog";
import { BaseButton } from "../../../common/base-button/base-button";

function PassengerDetails({ open, setOpen, passenger, actionOnPassenger }) {
    //general variables
    const { t } = useTranslation();

    //close modal
    const handleClose = () => {
        setOpen(false);
    };

    const dataList = [
        {
            id: 1,
            label: `${t("firstName")} ${t("lastName")}:`,
            value: (
                <Grid container item xs={12} direction="column" alignItems="center">
                    <span>
                        {passenger?.first_name || " "} {passenger?.last_name || " "}
                    </span>
                    <span>{passenger?.english_first_name + " " + passenger?.english_last_name}</span>
                </Grid>
            ),
        },
        { id: 2, label: `${t("gender")}:`, value: passenger?.gender?.name },
        { id: 3, label: `${t("nationalId")}:`, value: passenger?.national_code },
        { id: 4, label: `${t("phoneNumber")}:`, value: passenger?.phone_number },
        { id: 5, label: `${t("birthday")}:`, value: convertToJalali(passenger?.birthdate) },
        { id: 6, label: `${t("passport")}:`, value: passenger?.passport_no },
        { id: 7, label: `${t("passportExpire")}:`, value: passenger?.passport_expiry_date },
    ];

    const handleAction = (action, id) => {
        actionOnPassenger(action, id);
        handleClose();
    };

    return (
        <BaseDialog title={t("Passengers.Passenger Details")} open={open} handleClose={handleClose} maxWidth="lg" top="auto" icon="back" >
            <Grid className="passenger__details-modal" container item xs={12} rowGap={3}>
                <Grid container item xs={12} rowGap={1.5}>
                    {dataList?.map(item => {
                        return (
                            <Grid key={item.id} container item xs={12} rowGap={1.5} justifyContent="space-between" alignItems="center">
                                <span className="passenger__label">{item?.label}</span>
                                <span className="passenger__name">{item?.value}</span>
                                <Divider width="100%" sx={{ borderBottomColor: "var(--light-gray-color)" }} />
                            </Grid>
                        );
                    })}
                </Grid>

                <Grid container item xs={12} justifyContent="space-between">
                    <Grid container item xs={5.5}>
                        <BaseButton
                            text={t("General.Edit Information")}
                            color="secondary"
                            radius="radius-10"
                            size="large"
                            handleClick={() => handleAction("edit", passenger?.id)}
                        />
                    </Grid>
                    <Grid container item xs={5.5}>
                        <BaseButton
                            text={t("Passengers.Remove Passenger")}
                            color="red"
                            radius="radius-10"
                            size="large"
                            handleClick={() => handleAction("delete", passenger?.id)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </BaseDialog>
    );
}

export default PassengerDetails;
